"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigurableListsAsValueProvider = useConfigurableListsAsValueProvider;
const hooks_1 = require("../../../../ui/hooks");
const utils_1 = require("../../../../ui/utils");
function useConfigurableListsAsValueProvider() {
    const appName = (0, utils_1.getAppName)();
    const publicDataClient = (0, hooks_1.usePublicDataClient)(appName);
    const publicData = (0, hooks_1.usePublicDataGet)('configurableLists');
    return publicData.data
        ? publicData.data.map((item) => ({
            type: `configurableList.${item.name}`,
            label: item.name,
            getValues: () => publicDataClient.publicDataGetObject(`configurableList-${item.id}`),
        }))
        : undefined;
}
